import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export async function getAiLiveNow() {
  const { data } = await client.get('/ai-live/now');
  return data;
}

export async function getAiLiveGraph() {
  const { data } = await client.get('/ai-live/graph');
  return data;
}

export async function cleanupStalledProcesses() {
  const { data } = await client.post('/ai-live/cleanup');
  return data;
}

const aiLiveService = { getAiLiveNow, getAiLiveGraph, cleanupStalledProcesses };
export default aiLiveService;
